import "./RemoveCompletedTasks.scss";

function RemoveCompletedTasks({
  cancelRemoveCompletedTasks,
  removeCompletedTasks,
}) {
  return (
    <div className="remove-completed-tasks-content">
      <div className="modal-title">
        <div>Delete Completed Tasks</div>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to permanently delete all completed tasks?</p>
        <p>
          <strong>This action cannot be undone.</strong>
        </p>
      </div>
      <div className="modal-form-buttons">
        <button
          className="modal-button cancel"
          onClick={cancelRemoveCompletedTasks}
        >
          Cancel
        </button>
        <button className="modal-button save" onClick={removeCompletedTasks}>
          Delete
        </button>
      </div>
    </div>
  );
}

export default RemoveCompletedTasks;
